import type { Address } from '@/modules/address/domain/Address';

import type { CustomerRepository } from '../domain/CustomerRepository';

export const saveAddress = (
  repository: CustomerRepository,
  address: Address
) => {
  return repository.saveAddress(address);
};
